import { doc, getDocs, getDoc, collection } from "firebase/firestore";

import { db } from "./../firebase";

async function getAllSubCollectionItems(
  parentCollectionName,
  parentDocId,
  subCollectionName,
) {
  const subColRef = collection(
    db,
    parentCollectionName,
    parentDocId,
    subCollectionName,
  );

  const querySnapshot = await getDocs(subColRef);
  const items = [];

  querySnapshot.forEach((doc) => {
    items.push({ ...doc.data() });
  });

  return items; // Returns an array of objects, each containing the document ID and data
}

export async function getProject(id) {
  const docRef = doc(db, "projects", id);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const proj = docSnap.data();
    console.log("Got project data");
    if (
      proj.hasOwnProperty("projectStore_ids") &&
      proj.projectStore_ids.length > 0
    ) {
      var subCollectionItems = await getAllSubCollectionItems(
        "projects",
        id,
        "projectStore",
      );

      console.log(
        `Project has subcollections (${subCollectionItems.length}), merging data...`,
      );
      
      subCollectionItems.forEach((obj) => {
        for (var propt in obj) {
          if (propt !== "id" && proj.hasOwnProperty(propt)) {
            proj[propt] = [...proj[propt], ...obj[propt]];
          }
        }
      });
    }

    return proj;
  } else {
    throw new Error("No such document!");
  }
}
